import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ErrorBubbleFilledGlyph = /*#__PURE__*/createElement("g", {
  id: "error_1_"
}, /*#__PURE__*/createElement("path", {
  className: "st12",
  d: "M42,16c-14.5,0-26.3,11.8-26.3,26.3c0,12.5,8.7,22.9,20.3,25.6l2.6,2.9l3.5,5.2l5.3-7.8l0.1-0.2 c11.9-2.5,20.8-13.1,20.8-25.7C68.3,27.8,56.5,16,42,16z M52.6,53.6c-0.4,0.4-1.1,0.7-1.7,0.7c-0.6,0-1.2-0.2-1.7-0.7L42,46.4 l-7.3,7.3c-0.9,0.9-2.4,0.9-3.2,0c-0.4-0.4-0.6-1-0.6-1.6s0.2-1.2,0.6-1.6l7.3-7.3l-7.3-7.3c-0.4-0.4-0.6-1-0.6-1.6 c0-0.6,0.2-1.2,0.6-1.6c0.4-0.4,1-0.6,1.6-0.6s1.2,0.2,1.6,0.6l7.3,7.3l7.3-7.3c0.9-0.9,2.4-0.9,3.3,0c0.4,0.4,0.7,1.1,0.7,1.7 c0,0.6-0.2,1.2-0.7,1.7l-7.2,7.2l7.3,7.2c0.4,0.4,0.7,1.1,0.7,1.7C53.3,52.6,53,53.2,52.6,53.6z"
}));
const ErrorBubbleFilled = createSvg({
  name: 'error_bubble_filled',
  path: ErrorBubbleFilledGlyph
});

export default ErrorBubbleFilled;
export { ErrorBubbleFilledGlyph };
